<template>
  <div id="app">
    <navBar />
    <LeftNavBar />
    <b-container :class="containerClass">
      <router-view />
    </b-container>
  </div>
</template>

<script>
import NavBar from './views/layout/NavBar.vue';
import LeftNavBar from './views/layout/LeftNavBar.vue';

export default {
  components: { NavBar, LeftNavBar },
  computed: {
    containerClass() {
      if (this.$route.name === 'monitor') return 'allWidth'
      return ['ems', 'node', 'debugprojectlist', 'monitorlist', 'gatewayMonitor'].includes(this.$route.name)
        ? 'containerStyle'
        : '';
    },
  },
};
</script>

<style lang="scss">
#app {
  // width: 100vw;      /* 视口宽度，不是屏幕 */
  // height: 100vh;     /* 视口高度 */
  // overflow-x: hidden; /* 防止水平滚动条 */
}

.containerStyle {
  margin: 0 150px !important;
}

.allWidth {
  width: 100%;
  margin: 0 !important;
  padding: 0 !important;
}
</style>
